import { EditContactRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useEditContact() {
  const api = useApi();
  const [editing, setEditing] = useState(false);

  async function editContact(params: EditContactRequest) {
    try {
      setEditing(true);
      const res = await api.editContact(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setEditing(false);
    }
  }

  return { editing, editContact };
}
